// extracted by mini-css-extract-plugin
export default {"container":"_1Ka5_","date":"_13QEB","location":"_3VyKt","separator":"DEjvY"};